export class CheckListConfig {
  checklistId: number;
  checkListName: string;
  loanStatusId: number;
  //loanStatus: LoanStatus;
  questionConfiguration: string;
  currentVersion: ChecklistVersion;
  //companyModel: Company;

  companyId: number;
  insertedBy: string;
  dateInserted: Date;
  updatedBy: string;
  dateUpdated: Date;
}

export class ChecklistVersion {
  checklistVersionId: number;
  checklistId: number;
}

export class QuestionSummary {
  questionId: number;
  questionText: string;
  questionType: LookupType;
  checklistId: number;
  versionId: number;
  answers: QuestionAnswerSummary[]
  submittedAnswers: SubmittedAnswer[];
  userAnswer?: string | number | Array<number>;
}

export interface SubmittedAnswer {
  checklistAnswerId: number;
  answerText?: string;
  questionAnswerId?: number;
  applicationId: number;
  checklistVersionId: number;
  questionId: number;
}


export class QuestionAnswerSummary {
  questionAnswerId: number
  answerText: string;
}

export enum LookupType {
  TriggerOnly = "TriggerOnly",
  Immediately = "Immediately",
  OnLoanStatus = "OnLoanStatus",
  CreateInternalContact = "CreateInternalContact",
  UpdateInternalContact = "UpdateInternalContact",
  Private = "Private",
  Group = "Group",
  Public = "Public",
  Event = "Event",
  ToDo = "ToDo",
  Appointment = "Appointment",
  Al = "Al",
  AutoApply = "AutoApply",
  Confirm = "Confirm",
  RequestQuantity = "RequestQuantity",
  LoanCharacteristic = "LoanCharacteristic",
  BorrowerCharacteristic = "BorrowerCharacteristic",
  LessThan = "LessThan",
  LessThanOrEqualTo = "LessThanOrEqualTo",
  EqualTo = "EqualTo",
  GreatherThan = "GreatherThan",
  GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
  NullOrEmpty = "NullOrEmpty",
  NotNullOrEmpty = "NotNullOrEmpty",
  StartsWith = "StartsWith",
  Contains = "Contains",
  DoesNotContain = "DoesNotContain",
  In = "In",
  NotIn = "NotIn",
  MultiSelect = "MultiSelect",
  SelectList = "SelectList",
  Value = "Value",
  Docvalue = "Docvalue",
  DataValidation = "DataValidation",
  DocumentValidation = "DocumentValidation",
  ManualValidation = "ManualValidation",
  YesNo = "YesNo",
  TrueFalse = "TrueFalse",
  OnOff = "OnOff",
  Text = "Text",
  Integer = "Integer",
  Decimal = "Decimal",
  Pdf = "Pdf",
  Doc = "Doc",
  Txt = "Txt",
  Excel = "Excel",
  Csv = "Csv",
  Img = "Img",
  ApplyToLoan = "ApplyToLoan",
  ApplyToPrimaryBorrower = "ApplyToPrimaryBorrower",
  ApplyToSelectBorrowers = "ApplyToSelectBorrowers",
  ChangeStatus = "ChangeStatus",
  Uploadfile = "Uploadfile",
  DeleteFile = "DeleteFile",
  DownloadFile = "DownloadFile",
  ExportFile = "ExportFile",
  FileNoteUpdated = "FileNoteUpdated",
  BorrowerNoteUpdated = "BorrowerNoteUpdated",
  DeleteTask = "DeleteTask",
  RemoveFileFromTrash = "RemoveFileFromTrash",
  ConditionStatusChange = "ConditionStatusChange",
  CreateTask = "CreateTask",
  RestoreTask = "RestoreTask",
  MergeFile = "MergeFile",
  PostponeTask = "PostponeTask",
  ChangeFollowUpDate = "ChangeFollowUpDate",
  ChangeDueDate = "ChangeDueDate",
  ViewFile = "ViewFile",
  FileNameChanged = "FileNameChanged",
  ChangeConditionFlag = "ChangeConditionFlag",
  ChangeDescription = "ChangeDescription",
  ChangeNotifyParty = "ChangeNotifyParty",
  ChangePriority = "ChangePriority",
  ChangeResponsibleParty = "ChangeResponsibleParty",
  ChangeReviewRequired = "ChangeReviewRequired",
  AddCharacteristic = "AddCharacteristic",
  ChangeCharacteristic = "ChangeCharacteristic",
  RemoveCharacteristic = "RemoveCharacteristic",
  ChangeSubStatusOnly = "ChangeSubStatusOnly",
  ChangeEscalationUser = "ChangeEscalationUser",
  ESignStatusChange = "ESignStatusChange"
}
